import React, { useState } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import url from "../../../Component/server";
import axios from "axios";

const AdminFindAccount = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<"id" | "pw">("id");
  const [name, setName] = useState("");

  // Phone Auth State
  const [phone, setPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [timerVisible, setTimerVisible] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);

  // PW Reset State
  const [userid, setUserid] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [foundId, setFoundId] = useState("");

  const resetForm = () => {
    setPhone("");
    setName("");
    setPhoneCode("");
    setTimerVisible(false);
    setPhoneVerified(false);
    setUserid("");
    setNewPassword("");
    setNewPasswordConfirm("");
    setFoundId("");
  };

  const handleTabChange = (newTab: "id" | "pw") => {
    setTab(newTab);
    resetForm();
  };

  const requestPhoneAuth = async () => {
    if (!phone) return alert("연락처를 입력해주세요.");
    try {
      await axios.post(url.Communication_url.send_phone_auth, { phone, purpose: tab === "id" ? "find_id" : "reset_pw" });
      alert("인증번호가 발송되었습니다.");
      setTimerVisible(true);
    } catch (err: any) {
      alert(err.response?.data?.message || "발송 오류");
    }
  };

  const verifyPhoneCode = async () => {
    if (!phoneCode) return alert("인증번호를 입력해주세요.");
    try {
      await axios.post(url.Communication_url.verify_phone_auth, { phone, code: phoneCode, purpose: tab === "id" ? "find_id" : "reset_pw" });
      alert("인증이 완료되었습니다.");
      setPhoneVerified(true);
      setTimerVisible(false);
    } catch (err: any) {
      alert(err.response?.data?.message || "인증 실패");
    }
  };

  const handleFindId = async () => {
    if (!phoneVerified) return alert("휴대폰 인증을 진행해주세요.");
    if (!name.trim()) return alert("가입할 때 입력한 대표자명을 입력해주세요.");
    try {
      const res = await axios.post(url.Communication_url.seller_find_id, { name: name.trim(), phone });
      if (res.data && res.data.userid) {
        setFoundId(res.data.userid);
      }
    } catch (err: any) {
      alert(err.response?.data?.message || "아이디 찾기 실패");
    }
  };

  const handleResetPassword = async () => {
    if (!userid) return alert("아이디를 입력해주세요.");
    if (!phoneVerified) return alert("휴대폰 인증을 진행해주세요.");
    if (!newPassword || newPassword !== newPasswordConfirm) return alert("비밀번호가 일치하지 않거나 입력되지 않았습니다.");
    if (!/^[!-~]{5,72}$/.test(newPassword))
      return alert("새 비밀번호는 공백 없이 5~72자로 입력해주세요.");
    try {
      await axios.post(url.Communication_url.seller_reset_password, {
        userid,
        phone,
        new_password: newPassword
      });
      alert("비밀번호가 성공적으로 변경되었습니다.");
      navigate("/admin");
    } catch (err: any) {
      alert(err.response?.data?.message || "비밀번호 변경 실패");
    }
  };

  return (
    <Container>
      <Box>
        <div className="logo">
          <img
            style={{ height: 58 }}
            src={require("../../../Image/Logo_Text.png")}
            alt="팬버드"
          />
        </div>
        <h1>{tab === "id" ? "아이디 찾기" : "비밀번호 찾기"}</h1>
        
        <TabContainer>
          <Tab data-admin-tab="" data-active={tab === "id"} $active={tab === "id"} onClick={() => handleTabChange("id")}>아이디 찾기</Tab>
          <Tab data-admin-tab="" data-active={tab === "pw"} $active={tab === "pw"} onClick={() => handleTabChange("pw")}>비밀번호 찾기</Tab>
        </TabContainer>

        {tab === "id" ? (
          <>
            {foundId ? (
              <ResultBox>
                <p>고객님의 아이디는 <strong>{foundId}</strong> 입니다.</p>
                <Btn onClick={() => navigate("/admin")}>로그인 하러가기</Btn>
              </ResultBox>
            ) : (
              <>
                <label>대표자명</label>
                <InputBox
                  type="text"
                  placeholder="가입할 때 입력한 대표자명"
                  value={name}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                  readOnly={phoneVerified}
                />
                <label>휴대폰 번호</label>
                <FlexRow>
                  <InputBox 
                    type="number" 
                    placeholder="- 없이 입력" 
                    value={phone} 
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
                    readOnly={phoneVerified} 
                  />
                  <AuthBtn type="button" onClick={requestPhoneAuth} disabled={phoneVerified}>인증 요청</AuthBtn>
                </FlexRow>

                {timerVisible && !phoneVerified && (
                  <FlexRow style={{ marginTop: 10 }}>
                    <InputBox 
                      type="number" 
                      placeholder="인증번호 6자리" 
                      value={phoneCode} 
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhoneCode(e.target.value)}
                    />
                    <AuthBtn type="button" onClick={verifyPhoneCode}>인증 확인</AuthBtn>
                  </FlexRow>
                )}

                <Btn onClick={handleFindId} disabled={!phoneVerified} style={{ marginTop: 20 }}>아이디 찾기</Btn>
              </>
            )}
          </>
        ) : (
          <>
            <label>아이디</label>
            <InputBox 
              type="text" 
              placeholder="아이디를 입력해주세요" 
              value={userid} 
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUserid(e.target.value)}
            />

            <label>휴대폰 번호</label>
            <FlexRow>
              <InputBox 
                type="number" 
                placeholder="- 없이 입력" 
                value={phone} 
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
                readOnly={phoneVerified} 
              />
              <AuthBtn type="button" onClick={requestPhoneAuth} disabled={phoneVerified}>인증 요청</AuthBtn>
            </FlexRow>

            {timerVisible && !phoneVerified && (
              <FlexRow style={{ marginTop: 10 }}>
                <InputBox 
                  type="number" 
                  placeholder="인증번호 6자리" 
                  value={phoneCode} 
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhoneCode(e.target.value)}
                />
                <AuthBtn type="button" onClick={verifyPhoneCode}>인증 확인</AuthBtn>
              </FlexRow>
            )}

            {phoneVerified && (
              <>
                <label>새 비밀번호</label>
                <InputBox 
                  type="password" 
                  placeholder="새 비밀번호" 
                  value={newPassword} 
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value)}
                />
                
                <label>새 비밀번호 확인</label>
                <InputBox 
                  type="password" 
                  placeholder="새 비밀번호 확인" 
                  value={newPasswordConfirm} 
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPasswordConfirm(e.target.value)}
                />
              </>
            )}

            <Btn onClick={handleResetPassword} disabled={!phoneVerified} style={{ marginTop: 20 }}>비밀번호 변경</Btn>
          </>
        )}
        
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Link to="/admin" style={{ color: "var(--user-text-muted)", textDecoration: "none" }}>로그인으로 돌아가기</Link>
        </div>
      </Box>
    </Container>
  );
};

export default AdminFindAccount;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  padding: 2rem 1.5rem;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: radial-gradient(circle at 50% 10%, var(--user-surface) 0, var(--user-surface-muted) 42%, var(--user-accent-soft) 100%);
  color: var(--user-text);
  overflow-y: auto;
`;

const Box = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 36rem;
  padding: 3.5rem 4rem 3.25rem;
  margin: auto;
  background-color: var(--user-surface);
  border: 1px solid var(--user-border);
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(46, 25, 82, 0.12);
  h1 {
    margin: 2.25rem 0 1.5rem;
    font-size: 28px;
    font-weight: 700;
    color: var(--user-text);
    text-align: center;
  }
  label {
    display: block;
    margin-top: 1.5rem;
    margin-bottom: 9px;
    font-size: 14px;
    font-weight: 500;
  }
  @media (max-width: 600px) { padding: 2.25rem 1.5rem; h1 { font-size: 24px; } }
  div.logo {
    position: relative;
    height: 58px;
  }
  img {
    position: absolute;
    left: -2%;
  }
`;

const TabContainer = styled.div.attrs<{ 'data-admin-tabs'?: string }>({ 'data-admin-tabs': '' })`
  display: flex;
  border-bottom: 1px solid var(--user-border);
  margin-bottom: 1.5rem;
`;

const Tab = styled.div<{ $active: boolean }>`
  flex: 1;
  text-align: center;
  padding: 1rem 0;
  cursor: pointer;
  font-size: 16px;
  font-weight: ${props => props.$active ? "bold" : "normal"};
  color: ${props => props.$active ? "var(--user-accent)" : "var(--user-text-muted)"};
  border-bottom: ${props => props.$active ? "2px solid var(--user-accent)" : "none"};
`;

const InputBox = styled.input`
  background: var(--user-surface);
  color: var(--user-text);
  &::placeholder { color: var(--user-text-muted); }
  box-sizing: border-box;
  width: 100%;
  min-height: 50px;
  padding: 0.8rem 1rem;
  font-size: 15px;
  border-radius: 8px;
  border: 1px solid var(--user-border);
  outline: 0;
  &:focus {
    border: 1px solid var(--user-accent);
  }
  &[readOnly] {
    background-color: var(--user-surface-raised);
    color: var(--user-text-muted);
  }
`;

const FlexRow = styled.div`
  input { min-width: 0; }
  display: flex;
  gap: 8px;
`;

const AuthBtn = styled.button`
  min-width: 100px;
  background-color: var(--user-surface-raised);
  color: var(--user-text);
  border: 1px solid var(--user-border);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  
  &:disabled {
    cursor: not-allowed;
    color: var(--user-text-muted);
  }
`;

const Btn = styled.button`
  width: 100%;
  border: 0;
  min-height: 50px;
  padding: 0.95rem;
  background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep));
  color: white;
  font-size: 16px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    background: var(--user-surface-raised);
    color: var(--user-text-muted);
    cursor: not-allowed;
  }
`;

const ResultBox = styled.div`
  text-align: center;
  padding: 2rem 0;
  p {
    font-size: 18px;
    margin-bottom: 2rem;
  }
`;
